import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { fabric } from "fabric";
import { prepareTwoDMapData } from "../../../../action/2d_mapping/twoDMap.action";
import { const_var } from "../../../../redux/reducers/reducer";


const defaultCanvasOption = {
  preserveObjectStacking: true,
  selection: true,
  defaultCursor: 'default',
  backgroundColor: '#F8F8F8',
};

const canvasWidth = 794; //window.innerWidth;
const canvasHeight = 1123 - 180; // window.innerHeight - 160;

const entryLabelDict = {
  "garage_door": "C1",
  "garage_door_frameout": "C4",
  "walkin_frameout": "C5",
  "window_frameout": "C6",
  "walk_in_door": "C2",
  "walkin": "C2",
  "window": "C3"
};
const entryColor = {
  "garage_door": "#5ECBF6",
  "garage_door_frameout": "#5ECBF6",
  "walkin_frameout": "#5AEA9F",
  "window_frameout": "#F5966E",
  "walk_in_door": "#5AEA9F",
  "walkin": "#5AEA9F",
  "window": "#F5966E"
};

const extraLineStyle = {
  fill: 'rgba(0,0,0,0)',
  strokeWidth: 1,
  stroke: 'black',
  strokeDashArray: [1,1],
  selectable: false
};

class TwoDBuildingMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenSVG: false,
      isOpenPDF: false,
    };
    this.ref = React.createRef();
    this.options = {
      orientation: "landscape",
      unit: "in",
      format: [4, 2],
    };
    this.buildingFontSize = 13;
    this.entryFontSize = 11;
    //console.log("this.props", this.props);
    
  }

  draw2DLayout() {
    const mergedCanvasOption = Object.assign({}, defaultCanvasOption, {width: canvasWidth, height:canvasHeight});
    const buildingInfo = const_var.post_data?.building !== undefined && const_var.post_data.building?const_var.post_data.building:'No Data';
    this.drawLayout(this.canvas, mergedCanvasOption, buildingInfo);
  }

  componentDidMount() {
    const mergedCanvasOption = Object.assign({}, defaultCanvasOption, {width: canvasWidth, height:canvasHeight});
    this.canvas = new fabric.Canvas("fabric-canvas-"+this.props.purpose, mergedCanvasOption);
    if (this.props.purpose === 'save') {
      window.canvas2d = this.canvas;
    }
    this.draw2DLayout();
  }

  componentDidUpdate(prevProps) {
    if (this.props.purpose !== 'save' || prevProps.twoDMapData.layout2DMapId !== this.props.twoDMapData.layout2DMapId)
      this.draw2DLayout();
  }

  saveCanvasImage = (option = { name: 'New Image', format: 'png', quality: 1 }) => {
    const dataUrl = this.canvas.toDataURL(option);
    if (dataUrl) {
      const anchorEl = document.createElement('a');
      anchorEl.href = dataUrl;
      anchorEl.download = `${option.name}.png`;
      document.body.appendChild(anchorEl); // required for firefox
      anchorEl.click();
      anchorEl.remove();
    }
  };

  getSizeFeetLabel = (feet) => {
    let label = "";
    if (Math.floor(feet) !== 0)
      label += Math.floor(feet) + "\'";

    const inch = Math.round((feet - Math.floor(feet)) * 12);
    if (inch !== 0 )
      label += inch + "\""; 
    return label;
  }

  getEntryPointWidth = (entry) => {
    const entry_size = entry.entry_size;
    const entry_type = entry.entry_type;
    // let entry_width = entry_size.width;
    let entry_width = null;
    if ("entry_dimension_width" in entry) {
      entry_width = entry.entry_dimension_width;
    } else {
      let dimension = entry_size.name.split("x");
      entry_width = parseInt(dimension[0]);
    }
    
    if (entry_type === "garage_door") {
      
    } else if (entry_type === "garage_door_frameout") {
    } else {
      entry_width = entry_width / 12;
    }
    return entry_width;    
  }

  getEntryPointHeight = (entry) => {
    const entry_size = entry.entry_size;
    const entry_type = entry.entry_type;
    let entry_height = null;
    if ("entry_dimension_height" in entry) {
      entry_height = entry.entry_dimension_height;
    } else {
      let dimension = entry_size.name.split("x");
      entry_height = parseInt(dimension[1]);
    }
    
    if (entry_type === "garage_door") {
      
    } else if (entry_type === "garage_door_frameout") {
    } else {
      entry_height = entry_height / 12;
    }
    return entry_height;    
  }

  getAlignmentOffset = (leanto, totalSize, subSize) => {
    if (leanto.alignment === "front") {
      if (leanto.leanto_type === 1 || leanto.leanto_type === 2 || leanto.leanto_type === 4)
        return totalSize - subSize;
      else if (leanto.leanto_type === 3)
        return 0;
      else
        return 0;
    }
    if (leanto.alignment === "back" ) {
      if (leanto.leanto_type === 1 || leanto.leanto_type === 2 || leanto.leanto_type === 4) 
        return 0;
      else if (leanto.leanto_type === 3) 
        return totalSize - subSize;
      else
        return totalSize - subSize;
    }
    return (totalSize - subSize) / 2;
  }

  getAlignmentOffsetReverse = (leanto, totalSize, subSize) => {
    if (leanto.alignment === "front") {
      if (leanto.leanto_type === 1 || leanto.leanto_type === 2 || leanto.leanto_type === 4)
        return 0;
      else
        return totalSize - subSize;
    }
    if (leanto.alignment === "back" ) {
      if (leanto.leanto_type === 1 || leanto.leanto_type === 2 || leanto.leanto_type === 4) 
        return totalSize - subSize;
      else
        return 0;
    }
    return (totalSize - subSize) / 2;
  }

  getEntryPos = (entry) => {
    return entry.entry_position.z;
  }

  drawFrontBackExtraLine = (canvas, parent, entry, layout, position, building) => {
    if (position.right < position.left)
      return;
    const entry_size = entry.entry_size;
    const entry_type = entry.entry_type;
    const entry_location = entry.entry_location;
    let entry_width = this.getEntryPointWidth(entry);
    let entry_height = this.getEntryPointHeight(entry);
    let parent_width = parent.width;
    if (entry_location === "blbside" || entry_location === "flfside" || entry_location === "flulside" ||
      entry_location === 'bluside')
      parent_width = parent.length;
    let layout_width = layout.width;
    if ("total_width" in layout)
      layout_width = layout.total_width;

    let left = layout.left + layout_width * ((building.width - entry_width) / 2 + position.left) / parent_width;
    if ("leanto_type" in parent) {
      if (parent["leanto_type"] ===  1)
        left += layout.width
      else if (parent["leanto_type"] ===  2)
        left -= layout.width * building.width / parent.width;
      else if (parent["leanto_type"] ===  3 || parent["leanto_type"] === 4)
        left -= this.getAlignmentOffset(parent, building.width, parent_width) * layout.width / parent_width;
    }

    let right = layout.left + layout_width * ((building.width - entry_width) / 2 + position.right) / parent_width;
    if ("leanto_type" in parent) {
      if (parent["leanto_type"] ===  1)
        right += layout.width;
      else if (parent["leanto_type"] ===  2)
        right -= layout.width * building.width / parent_width;
      else if (parent["leanto_type"] ===  3 || parent["leanto_type"] === 4)
        right -= this.getAlignmentOffset(parent, building.width, parent_width) * layout.width / parent_width;
    }

    let top = layout.top;
    let width = layout_width * entry_width / parent_width;

    let front = true;
    if (entry_location === "fend" || entry_location === "ufend" || 
      entry_location === "llfend" || entry_location === "rlfend" ||
      entry_location === "flfside" || entry_location === "lufend" ||
      entry_location === "rufend" || entry_location === "flulside" ||
      entry_location === 'llufend' || entry_location === 'rlufend') {
      top = top + layout.length;
      front = true;
    } else {
      front = false;
    }

    const lineExtraLeft = new fabric.Line([
      left, top + 20 * (front ? 1 : -1),
      right, top + 20 * (front ? 1 : -1)
     ], extraLineStyle);
    canvas.add(lineExtraLeft);
    
    const textExtraLeft = new fabric.Text(this.getSizeFeetLabel(position.right - position.left), {
      fontSize: this.entryFontSize,
      left: (left + right) / 2,
      top: top + 25 * (front ? 1 : -1),
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(0,0,0,0)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
    });
    canvas.add(textExtraLeft);
  }

  drawSideExtraLine = (canvas, parent, entry, layout, position, building) => {
    if (position.bottom < position.top)
      return;
    const entry_size = entry.entry_size;
    const entry_type = entry.entry_type;
    const entry_location = entry.entry_location;
    let entry_height = this.getEntryPointWidth(entry);
    let leanto_type = 0;
    if ("leanto_type" in parent)
      leanto_type = parent.leanto_type;

    let top = layout.top + layout.length * ((building.length - entry_height) / 2 + position.top) / parent.length;
    if (leanto_type === 1 || leanto_type === 2)
      top -= this.getAlignmentOffset(parent, building.length, parent.length) * layout.length / parent.length;
    else if (leanto_type === 3)
      top = layout.top + layout.length * ((building.length - entry_height) / 2 + position.top - building.length) / parent.width;
    else if (leanto_type === 4)
      top = layout.top + layout.length * ((building.length - entry_height) / 2 + position.top + parent.width) / parent.width;;

    let bottom = layout.top + layout.length * ((building.length - entry_height) / 2 + position.bottom) / parent.length;
    if (leanto_type === 1 || leanto_type === 2)
      bottom -= this.getAlignmentOffset(parent, building.length, parent.length) * layout.length / parent.length;
    else if (leanto_type === 3)
      bottom = layout.top + layout.length * ((building.length - entry_height) / 2 + position.bottom - building.length) / parent.width;
    else if (leanto_type === 4)
      bottom = layout.top + layout.length * ((building.length - entry_height) / 2 + position.bottom + parent.width) / parent.width;

    let left = layout.left;
    let length = layout.length * entry_height / parent.length;
    let right_side = false;
    if (entry_location === "rside" || entry_location === "rlrside" || entry_location === 'ulside' ||
      entry_location === 'rfend' || entry_location === 'llurside' || entry_location === 'rrurside') {
      left = left + layout.width;
      right_side = true;
    }
    if (leanto_type === 3 && (
      entry_location === "flfend" || 
      entry_location === 'flurside' || entry_location === 'flufend')) {
      left = left + layout.width;
      right_side = true;
    }
    if (leanto_type === 4 && entry_location === "blfend") {
      left = left + layout.width;
      right_side = true;
    }

    const lineExtraLeft = new fabric.Line([
      left + 20 * (right_side ? 1 : -1), top,
      left + 20 * (right_side ? 1 : -1), bottom
     ], extraLineStyle);
    canvas.add(lineExtraLeft);
    
    const textExtraLeft = new fabric.Text(this.getSizeFeetLabel(position.bottom - position.top), {
      fontSize: this.entryFontSize,
      top: (top + bottom) / 2,
      left: left + 25 * (right_side ? 1 : -1),
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(0,0,0,0)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
      angle: 270
    });
    canvas.add(textExtraLeft);
  }

  drawFrontBackEntryPoint = (canvas, parent, entry, layout, building) => {
    const entry_position = entry.entry_position;
    const entry_size = entry.entry_size;
    const entry_type = entry.entry_type;
    const entry_location = entry.entry_location;
    // let entry_width = entry_size.width;
    // let entry_height = entry_size.height;
    let entry_width = 0;  // entry.entry_dimension_width;
    let entry_height = 0;  // entry.entry_dimension_height;
    if ("entry_dimension_width" in entry) {
      entry_width = entry.entry_dimension_width;
    } else {
      let dimension = entry_size.name.split("x");
      entry_width = parseInt(dimension[0]);
    }
    if ("entry_dimension_height" in entry) {
      entry_height = entry.entry_dimension_height;
    } else {
      let dimension = entry_size.name.split("x");
      entry_height = parseInt(dimension[1]);
    }
    let entry_label = entryLabelDict[entry_type];
    let size_label = "";
    let parent_width = parent.width;
    if (entry_location === "blbside" || entry_location === "flfside" || entry_location === 'flulside' ||
      entry_location === 'bluside')
      parent_width = parent.length;

    let layout_width = layout.width;
    if ("total_width" in layout)
      layout_width = layout.total_width;

    
    if (entry_type === "garage_door") {
      size_label = entry_width + "\'*" + entry_height + "\'";
    } else if (entry_type === "garage_door_frameout") {
      size_label = entry_width + "\'*" + entry_height + "\'";
    } else {
      size_label = entry_width + "\"*" + entry_height + "\"";
      entry_width = entry_width / 12;
    }
    let left = layout.left + layout_width * ((building.width - entry_width) / 2 + entry_position.x) / parent_width;
    if ("leanto_type" in parent) {
      if (parent["leanto_type"] ===  1)
        left += layout.width;
      else if (parent["leanto_type"] ===  2)
        left -= layout.width * building.width / parent_width;
      else if (parent["leanto_type"] ===  3 || parent["leanto_type"] ===  4)
        left -= this.getAlignmentOffset(parent, building.width, parent_width) * layout.width / parent_width;
    }

    let top = layout.top;
    let width = layout_width * entry_width / parent_width;

    let front = true;
    if (entry_location === "fend" || entry_location === "ufend" || 
      entry_location === "llfend" || entry_location === "rlfend" ||
      entry_location === "flfside" || entry_location === "lufend" ||
      entry_location === "rufend" || entry_location === "flulside" ||
      entry_location === 'llufend' || entry_location === 'rlufend') {
      top = top + layout.length;
      front = true;
    } else {
      front = false;
    }

    const bound = new fabric.Rect({
      width: width,
      height: 3,
      fill: 'rgba(255,255,255)',
      strokeWidth: 1,
      stroke: 'black',
      top: top,
      left: left,
      selectable: false
    });
    canvas.add(bound);

    const textMark = new fabric.Text(entry_label, {
      fontSize: this.entryFontSize,
      left: left + width / 2,
      top: top + 2,
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(105,203,240)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
    });
    canvas.add(textMark);

    let strokeDashArray = [1, 1];
    const lineWidth = new fabric.Line([
      left, top + 10 * (front ? 1 : -1),
      left + width, top + 10 * (front ? 1 : -1)
     ],{
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 1,
      stroke: 'black',
      strokeDashArray: strokeDashArray,
      selectable: false
    });
    canvas.add(lineWidth);

    const textLabel = new fabric.Text(size_label, {
      fontSize: this.entryFontSize,
      left: left + width / 2,
      top: top + 15 * (front ? 1 : -1),
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(0,0,0,0)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
    });
    canvas.add(textLabel);
  }


  drawSideEntryPoint = (canvas, parent, entry, layout, building) => {
    const entry_position = entry.entry_position;
    const entry_size = entry.entry_size;
    const entry_type = entry.entry_type;
    const entry_location = entry.entry_location;
    // let entry_width = entry_size.width;
    // let entry_height = entry_size.height;
    let entry_width = 0;  // entry.entry_dimension_width;
    let entry_height = 0;  // entry.entry_dimension_height;
    if ("entry_dimension_width" in entry) {
      entry_width = entry.entry_dimension_width;
    } else {
      let dimension = entry_size.name.split("x");
      entry_width = parseInt(dimension[0]);
    }
    if ("entry_dimension_height" in entry) {
      entry_height = entry.entry_dimension_height;
    } else {
      let dimension = entry_size.name.split("x");
      entry_height = parseInt(dimension[1]);
    }
    let entry_label = entryLabelDict[entry_type];
    let entry_color = entryColor[entry_type];
    let size_label = "";
    
    if (entry_type === "garage_door") {
      size_label = entry_width + "\'*" + entry_height + "\'";
    } else if (entry_type === "garage_door_frameout") {
      size_label = entry_width + "\'*" + entry_height + "\'";
    } else {
      size_label = entry_width + "\"*" + entry_height + "\"";
      entry_width = entry_width / 12;
    }
    entry_height = entry_width;
    let top = layout.top + layout.length * ((building.length - entry_height) / 2 + entry_position.z) / parent.length;
    let leanto_type = 0;
    if ("leanto_type" in parent)
      leanto_type = parent.leanto_type;
    if (leanto_type === 1 || leanto_type === 2)
      top -= this.getAlignmentOffset(parent, building.length, parent.length) * layout.length / parent.length;
    else if (leanto_type === 3)
      top = layout.top + layout.length * ((building.length - entry_height) / 2 + this.getEntryPos(entry) - building.length) / parent.width;
    else if (leanto_type === 4)
      top = layout.top + layout.length * ((building.length - entry_height) / 2 + this.getEntryPos(entry) + parent.width) / parent.width;;

    let left = layout.left;
    let height = layout.length * entry_height / parent.length;
    let right_side = false;
    if (entry_location === "rside" || entry_location === "rlrside" || entry_location === "ulside" ||
      entry_location === 'rfend' || entry_location === 'llurside' || entry_location === 'rrurside') {
      left = left + layout.width;
      right_side = true;
    }
    if (leanto_type === 3 && (
      entry_location === "flfend" ||
      entry_location === 'flurside' || entry_location === 'flufend')) {
      left = left + layout.width;
      right_side = true;
    }
    if (leanto_type === 4 && entry_location === "blfend") {
      left = left + layout.width;
      right_side = true;
    }
    if (leanto_type === 3 || leanto_type === 4)
      height = layout.length * entry_height / parent.width;

    const bound = new fabric.Rect({
      width: 3,
      height: height,
      fill: 'rgba(255,255,255)',
      strokeWidth: 1,
      stroke: 'black',
      top: top,
      left: left,
      selectable: false
    });
    canvas.add(bound);

    const textMark = new fabric.Text(entry_label, {
      fontSize: this.entryFontSize,
      left: left + 2,
      top: top + height / 2,
      fill: 'rgb(0,0,0)',
      backgroundColor: entry_color,
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
    });
    canvas.add(textMark);

    let strokeDashArray = [1, 1];
    const lineWidth = new fabric.Line([
      left + 10 * (right_side ? 1 : -1), top,
      left + 10 * (right_side ? 1 : -1), top + height
     ],{
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 1,
      stroke: 'black',
      strokeDashArray: strokeDashArray,
      selectable: false
    });
    canvas.add(lineWidth);

    const textLabel = new fabric.Text(size_label, {
      fontSize: this.entryFontSize,
      left: left + 15 * (right_side ? 1 : -1),
      top: top + height / 2,
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(0,0,0,0)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
      angle: 270
    });
    canvas.add(textLabel);
  }

  drawLeftRightEntryPoints = (canvas, parent, entry_points, layout, building) => {
    if (entry_points.length == 0) 
      return;

    entry_points.sort((a, b) => (this.getEntryPos(a) > this.getEntryPos(b)) ? 1 : -1)

    let leanto_offset = 0;
    let leanto_type = 0;
    if ("leanto_type" in parent) {
      leanto_type = parent.leanto_type;
    }
    if(leanto_type === 1)
      leanto_offset = this.getAlignmentOffset(parent, building.length, parent.length);
    else if(leanto_type === 2)
      leanto_offset = this.getAlignmentOffset(parent, building.length, parent.length);
    else if(leanto_type === 3)
      leanto_offset = building.length;
    else if(leanto_type === 4)
      leanto_offset = -1 * parent.width;

    let position = {
      top: -1 * (building.length - this.getEntryPointWidth(entry_points[0])) / 2 + leanto_offset,
      bottom: this.getEntryPos(entry_points[0])
    };

    this.drawSideExtraLine(canvas, parent, entry_points[0], layout, position, building);

    for (let i=0; i<entry_points.length; i++) {
      this.drawSideEntryPoint(canvas, parent, entry_points[i], layout, building);
      if (i < entry_points.length - 1) {
        position.top = position.bottom + this.getEntryPointWidth(entry_points[i]) / 2 + this.getEntryPointWidth(entry_points[i+1]) / 2;
        position.bottom = this.getEntryPos(entry_points[i+1]);
        this.drawSideExtraLine(canvas, parent, entry_points[i+1], layout, position, building);
      }
    }
    let last_entry_point = entry_points[entry_points.length-1];
    position.top = position.bottom + this.getEntryPointWidth(last_entry_point) / 2 + this.getEntryPointWidth(last_entry_point) / 2;
    position.bottom = building.length / 2 + this.getEntryPointWidth(last_entry_point) / 2;
    if (leanto_type === 1 || leanto_type === 2)
      position.bottom -= this.getAlignmentOffsetReverse(parent, building.length, parent.length);
    else if (leanto_type === 3)
      position.bottom += parent.width;
    else if (leanto_type === 4)
      position.bottom -= building.length;
    this.drawSideExtraLine(canvas, parent, last_entry_point, layout, position, building);
  }

  drawFrontBackEntryPoints = (canvas, parent, entry_points, layout, building) => {
    if (entry_points.length == 0) 
      return;

    entry_points.sort((a, b) => (a.entry_position.x > b.entry_position.x) ? 1 : -1)
    let leanto_offset = 0;
    if ("leanto_type" in parent) {
      if(parent["leanto_type"] === 1)
        leanto_offset = -1 * parent.width;
      else if(parent["leanto_type"] === 2)
        leanto_offset = 1 * building.width;
      else if(parent["leanto_type"] === 3 || parent["leanto_type"] === 4)
        leanto_offset = this.getAlignmentOffset(parent, building.width,  parent.length);
    }
    let position = {
      left: -1 * (building.width - this.getEntryPointWidth(entry_points[0])) / 2 + leanto_offset,
      right: entry_points[0].entry_position.x
    };

    this.drawFrontBackExtraLine(canvas, parent, entry_points[0], layout, position, building);

    for (let i=0; i<entry_points.length; i++) {
      this.drawFrontBackEntryPoint(canvas, parent, entry_points[i], layout, building);
      if (i < entry_points.length - 1) {
        position.left = position.right + this.getEntryPointWidth(entry_points[i]) / 2 + this.getEntryPointWidth(entry_points[i+1]) / 2;
        position.right = entry_points[i+1].entry_position.x;
        this.drawFrontBackExtraLine(canvas, parent, entry_points[i+1], layout, position, building);
      }
    }
    let last_entry_point = entry_points[entry_points.length-1];
    position.left = position.right + this.getEntryPointWidth(last_entry_point) / 2 + this.getEntryPointWidth(last_entry_point) / 2;
    position.right = building.width / 2 + this.getEntryPointWidth(last_entry_point) / 2;
    if(parent["leanto_type"] === 1)
      position.right = -1 * (building.width  - this.getEntryPointWidth(last_entry_point))/2;
    else if(parent["leanto_type"] === 2)
      position.right = building.width/2 + parent.width + this.getEntryPointWidth(last_entry_point)/2;
    else if(parent["leanto_type"] === 3)
      position.right -= this.getAlignmentOffsetReverse(parent, building.width,  parent.length);
    else if(parent["leanto_type"] === 4)
      position.right -= this.getAlignmentOffsetReverse(parent, building.width,  parent.length);
    this.drawFrontBackExtraLine(canvas, parent, last_entry_point, layout, position, building);
  }

  drawUtilityBorder = (canvas, object, layout) => {
    const utilityBound = new fabric.Rect({
      width: layout.width,
      height: layout.length,
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 4,
      stroke: 'black',
      top: layout.top,
      left: layout.left,
      selectable: false
    });
    canvas.add(utilityBound);

    const padding = 40;
    const utilityLeftLine = new fabric.Line([
      layout.left + padding, layout.top,
      layout.left + padding, layout.top+layout.length
     ],{
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 1,
      stroke: 'black',
      strokeDashArray: [5, 5],
      selectable: false
    });
    const leftLabel = new fabric.Text("SL " + object['utility_length'].toString() + "\'", {
      fontSize: this.buildingFontSize,
      left: layout.left + padding,
      top: layout.top + layout.length / 2,
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(255,255,255)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
      angle: 270
    });

    if (!("leanto_type" in object) || object['leanto_type'] == 1) {
      canvas.add(utilityLeftLine);
      canvas.add(leftLabel);
    }

    const utilityRightLine = new fabric.Line([
      layout.left + layout.width - padding, layout.top,
      layout.left + layout.width - padding, layout.top+layout.length
     ],{
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 1,
      stroke: 'black',
      strokeDashArray: [5, 5],
      selectable: false
    });
    const rightLabel = new fabric.Text("SL " + object['utility_length'].toString() + "\'", {
      fontSize: this.buildingFontSize,
      left: layout.left + layout.width - padding,
      top: layout.top + layout.length / 2,
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(255,255,255)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
      angle: 270
    });
    if (!("leanto_type" in object) || object['leanto_type'] == 2) {
      canvas.add(utilityRightLine);
      canvas.add(rightLabel);
    }

    const utilityTopLine = new fabric.Line([
      layout.left, layout.top + padding,
      layout.left + layout.width, layout.top + padding
     ],{
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 1,
      stroke: 'black',
      strokeDashArray: [5, 5],
      selectable: false
    });
    const topLabel = new fabric.Text("SL " + object['utility_length'].toString() + "\'", {
      fontSize: this.buildingFontSize,
      left: layout.left + layout.width / 2,
      top: layout.top + padding,
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(255,255,255)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
    });
    if (object['leanto_type'] == 3 || object['leanto_type'] == 4) {
      canvas.add(utilityTopLine);
      canvas.add(topLabel);
    }
  }

  drawSideUtilityBorder = (canvas, object, layout) => {
    const utilityBound = new fabric.Rect({
      width: layout.width,
      height: layout.length,
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 4,
      stroke: 'black',
      top: layout.top,
      left: layout.left,
      selectable: false
    });
    canvas.add(utilityBound);

    const padding = 40;
    const utilityTopLine = new fabric.Line([
      layout.left, layout.top + padding,
      layout.left + layout.width, layout.top + padding
     ],{
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 1,
      stroke: 'black',
      strokeDashArray: [5, 5],
      selectable: false
    });
    const topLabel = new fabric.Text("SL " + object['utility_length'].toString() + "\'", {
      fontSize: this.buildingFontSize,
      left: layout.left + layout.width / 2,
      top: layout.top + padding,
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(255,255,255)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
    });

    if (!("leanto_type" in object) || object['leanto_type'] == 1) {
      canvas.add(utilityTopLine);
      canvas.add(topLabel);
    }

    const utilityBottomLine = new fabric.Line([
      layout.left, layout.top + layout.length - padding,
      layout.left + layout.width, layout.top + layout.length - padding
     ],{
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 1,
      stroke: 'black',
      strokeDashArray: [5, 5],
      selectable: false
    });
    const bottomLabel = new fabric.Text("SL " + object['utility_length'].toString() + "\'", {
      fontSize: this.buildingFontSize,
      left: layout.left + layout.width / 2,
      top: layout.top + layout.length - padding,
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(255,255,255)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
    });
    if (!("leanto_type" in object) || object['leanto_type'] == 2) {
      canvas.add(utilityBottomLine);
      canvas.add(bottomLabel);
    }
  }

  drawSideCombo = (canvas, object, layout) => {
    const padding = 40;
    let sideDirection = object['utility_name'];
    const sideLine = new fabric.Line([
        layout.left + (sideDirection === 'left' ? layout.width : 0), layout.top,
        layout.left + (sideDirection === 'left' ? layout.width : 0), layout.top + layout.length
      ], {
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 4,
      stroke: 'black',
      strokeDashArray: [5, 0],
      selectable: false
    });
    canvas.add(sideLine);

    const sideTopLine = new fabric.Line([
      layout.left, layout.top + padding,
      layout.left + layout.width, layout.top + padding
     ],{
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 1,
      stroke: 'black',
      strokeDashArray: [5, 5],
      selectable: false
    });
    const topLabel = new fabric.Text("SL " + object['utility_length'].toString() + "\'", {
      fontSize: this.buildingFontSize,
      left: layout.left + layout.width / 2,
      top: layout.top + padding,
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(255,255,255)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
    });
    canvas.add(sideTopLine);
    canvas.add(topLabel);
  }

  drawPorch = (canvas, layout, loc, wall) => {
    const lineSideStyle = {
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 4,
      stroke: 'black',
      strokeDashArray: [5, 0],
      selectable: false
    };
    if (wall['side_wall'] === 'open')
      lineSideStyle['strokeDashArray'] = [5, 5];

    const lineBackStyle = {
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 4,
      stroke: 'black',
      strokeDashArray: [5, 0],
      selectable: false
    };
    if (wall['back_wall'] === 'open')
      lineBackStyle['strokeDashArray'] = [5, 5];

    const leftLine = new fabric.Line([
        layout.left, layout.top,
        layout.left, layout.top + layout.length
      ], lineSideStyle);

    const rightLine = new fabric.Line([
        layout.left + layout.width, layout.top,
        layout.left + layout.width, layout.top + layout.length
      ], lineSideStyle);

    const topLine = new fabric.Line([
        layout.left, layout.top,
        layout.left + layout.width, layout.top
      ], lineBackStyle);

    const bottomLine = new fabric.Line([
        layout.left, layout.top + layout.length,
        layout.left + layout.width, layout.top + layout.length
      ], lineBackStyle);

    if (loc === "top-left" || loc === "bottom-left")
      canvas.add(leftLine);

    if (loc === "top-right" || loc === "bottom-right")
      canvas.add(rightLine);

    if (loc === "top-left" || loc === "top-right")
      canvas.add(topLine);

    if (loc === "bottom-left" || loc === "bottom-right")
      canvas.add(bottomLine);
  }

  drawLeanto = (canvas, leanto, layout) => {
    const top = layout.top;
    const left = layout.left;
    const width = layout.width;
    const length = layout.length;
    let leanto_length = leanto.length;
    let leanto_width = leanto.width;
    if (leanto.leanto_type == 3 || leanto.leanto_type == 4) {
      leanto_length = leanto.width;
      leanto_width = leanto.length;      
    }
    let prefix = "";
    if (leanto.leanto_type == 1)
      prefix = "L-";
    else if (leanto.leanto_type == 2)
      prefix = "R-";

    let strokeDashArray = [];
    if (leanto.leanto_type !== 2) {
      if (leanto.side_wall=="open")
        strokeDashArray = [5, 5];
      else
        strokeDashArray = [5, 0];
      const leftOutterBound = new fabric.Line([
        left, top,
        left, top+length
       ],{
        fill: 'rgba(0,0,0,0)',
        strokeWidth: 4,
        stroke: 'black',
        strokeDashArray: strokeDashArray,
        selectable: false
      });
      canvas.add(leftOutterBound);

      const leftInnerBound = new fabric.Line([
        left + 10, top + 10,
        left + 10, top+length-10
       ],{
        fill: 'rgba(0,0,0,0)',
        stroke: 'black',
        selectable: false
      });
      canvas.add(leftInnerBound);

      const textLeftBorder = new fabric.Text(prefix + "LEFT " + leanto_length.toString() + "\'", {
        fontSize: this.buildingFontSize,
        left: left + 10,
        top: top + length /2,
        fill: 'rgb(0,0,0)',
        backgroundColor: 'rgb(255,255,255)',
        originX: 'center',
        originY: 'center',
        fontWeight: 600,
        angle: 90
      });
      canvas.add(textLeftBorder);
    }

    if (leanto.leanto_type !== 1) {
      if (leanto.side_wall=="open")
        strokeDashArray = [5, 5];
      else
        strokeDashArray = [5, 0];
      const rightOutterBound = new fabric.Line([
        left + width, top,
        left + width, top+length
       ],{
        fill: 'rgba(0,0,0,0)',
        strokeWidth: 4,
        stroke: 'black',
        strokeDashArray: strokeDashArray,
        selectable: false
      });
      canvas.add(rightOutterBound);

      const rightInnerBound = new fabric.Line([
        left + width - 10, top + 10,
        left + width - 10, top + length - 10
       ],{
        fill: 'rgba(0,0,0,0)',
        stroke: 'black',
        selectable: false
      });
      canvas.add(rightInnerBound);

      const textRightBorder = new fabric.Text(prefix + "RIGHT " + leanto_length.toString() + "\'", {
        fontSize: this.buildingFontSize,
        left: left + width - 10,
        top: top + length/2,
        fill: 'rgb(0,0,0)',
        backgroundColor: 'rgb(255,255,255)',
        originX: 'center',
        originY: 'center',
        fontWeight: 600,
        angle: 90
      });
      canvas.add(textRightBorder);
    }

    if (leanto.leanto_type !== 3) {
      if (leanto.back_wall=="open")
        strokeDashArray = [5, 5];
      else
        strokeDashArray = [5, 0];
      const topOutterBound = new fabric.Line([
        left, top,
        left+width, top
       ],{
        fill: 'rgba(0,0,0,0)',
        strokeWidth: 4,
        stroke: 'black',
        strokeDashArray: strokeDashArray,
        selectable: false
      });
      canvas.add(topOutterBound);
      const topInnerBound = new fabric.Line([
        left + 10, top + 10,
        left + width - 10, top + 10
       ],{
        fill: 'rgba(0,0,0,0)',
        stroke: 'black',
        selectable: false
      });
      canvas.add(topInnerBound);

      const textTopBorder = new fabric.Text(prefix + "BACK " + leanto_width.toString() + "\'", {
        fontSize: this.buildingFontSize,
        left: left + width / 2,
        top: top + 10,
        fill: 'rgb(0,0,0)',
        backgroundColor: 'rgb(255,255,255)',
        originX: 'center',
        originY: 'center',
        fontWeight: 600,
      });
      canvas.add(textTopBorder);
    }

    if (leanto.leanto_type !== 4) {
      if (leanto.front_wall=="open")
        strokeDashArray = [5, 5];
      else
        strokeDashArray = [5, 0];
      const bottomOutterBound = new fabric.Line([
        left, top + length,
        left + width, top + length
       ],{
        fill: 'rgba(0,0,0,0)',
        strokeWidth: 4,
        stroke: 'black',
        strokeDashArray: strokeDashArray,
        selectable: false
      });
      canvas.add(bottomOutterBound);
      const bottomInnerBound = new fabric.Line([
        left + 10, top + length - 10,
        left + width - 10, top + length - 10
       ],{
        fill: 'rgba(0,0,0,0)',
        stroke: 'black',
        selectable: false
      });
      canvas.add(bottomInnerBound);

      const textBottomBorder = new fabric.Text(prefix + "FRONT " + leanto_width.toString() + "\'", {
        fontSize: this.buildingFontSize,
        left: left + width / 2,
        top: top + length - 10,
        fill: 'rgb(0,0,0)',
        backgroundColor: 'rgb(255,255,255)',
        originX: 'center',
        originY: 'center',
        fontWeight: 600,
      });
      canvas.add(textBottomBorder);
    }
    const textCenter = new fabric.Text(leanto_width.toString() + "\' WIDE * " + leanto_length.toString() + "\' LONG *" + leanto.height.toString() + "\' TALL", {
      fontSize: this.entryFontSize,
      left: left + width / 2,
      top: top + length / 2,
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(255,255,255)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
      skipWrapping: false,
    });
    canvas.add(textCenter);
  }

  drawMainBuilding = (canvas, building, layout) => {
    const top = layout.top;
    const left = layout.left;
    const width = layout.width;
    const length = layout.length;

    let strokeDashArray = [];
    if (building.left_wall=="open")
      strokeDashArray = [5, 5];
    else
      strokeDashArray = [5, 0];
    const leftOutterBound = new fabric.Line([
      left, top,
      left, top+length
     ],{
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 4,
      stroke: 'black',
      strokeDashArray: strokeDashArray,
      selectable: false
    });

    if (building.right_wall=="open")
      strokeDashArray = [5, 5];
    else
      strokeDashArray = [5, 0];
    const rightOutterBound = new fabric.Line([
      left + width, top,
      left + width, top+length
     ],{
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 4,
      stroke: 'black',
      strokeDashArray: strokeDashArray,
      selectable: false
    });

    if (building.back_wall=="open")
      strokeDashArray = [5, 5];
    else
      strokeDashArray = [5, 0];
    const topOutterBound = new fabric.Line([
      left, top,
      left+width, top
     ],{
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 4,
      stroke: 'black',
      strokeDashArray: strokeDashArray,
      selectable: false
    });

    if (building.front_wall=="open")
      strokeDashArray = [5, 5];
    else
      strokeDashArray = [5, 0];
    const bottomOutterBound = new fabric.Line([
      left, top + length,
      left + width, top + length
     ],{
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 4,
      stroke: 'black',
      strokeDashArray: strokeDashArray,
      selectable: false
    });

    const innerBound = new fabric.Rect({
      width: width - 20,
      height: length - 20,
      fill: 'rgba(0,0,0,0)',
      strokeWidth: 1,
      stroke: 'black',
      top: top + 10,
      left: left + 10,
      selectable: false
    });
    const textTopBorder = new fabric.Text("BACK " + building.width.toString() + "\'", {
      fontSize: this.buildingFontSize,
      left: left + width / 2,
      top: top + 10,
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(255,255,255)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
    });
    const textBottomBorder = new fabric.Text("FRONT " + building.width.toString() + "\'", {
      fontSize: this.buildingFontSize,
      left: left + width / 2,
      top: top + length - 10,
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(255,255,255)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
    });
    const textLeftBorder = new fabric.Text("LEFT " + building.length.toString() + "\'", {
      fontSize: this.buildingFontSize,
      left: left + 10,
      top: top + length /2,
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(255,255,255)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
      angle: 90
    });
    const textRightBorder = new fabric.Text("RIGHT " + building.length.toString() + "\'", {
      fontSize: this.buildingFontSize,
      left: left + width - 10,
      top: top + length/2,
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(255,255,255)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
      angle: 90
    });
    const textCenter = new fabric.Text(building.width.toString() + "\' WIDE * " + building.length.toString() + "\' LONG *" + building.height.toString() + "\' TALL", {
      fontSize: this.buildingFontSize,
      left: left + width / 2,
      top: top + length / 2,
      fill: 'rgb(0,0,0)',
      backgroundColor: 'rgb(255,255,255)',
      originX: 'center',
      originY: 'center',
      fontWeight: 600,
      skipWrapping: false,
    });
    canvas.add(leftOutterBound);
    canvas.add(rightOutterBound);
    canvas.add(topOutterBound);
    canvas.add(bottomOutterBound);
    canvas.add(innerBound);
    canvas.add(textTopBorder);
    canvas.add(textBottomBorder);
    canvas.add(textLeftBorder);
    canvas.add(textRightBorder);
    canvas.add(textCenter);
  }

  drawLayout = (canvas, mergedCanvasOption, buildingInfo) => {
    canvas.clear();
    const buildingWidth = buildingInfo.width;
    const buildingLength = buildingInfo.length;
    const buildingHeight = buildingInfo.height;
    let totalWidth = buildingWidth;
    let totalLength = buildingLength;
    let leftLeanto = null;
    let rightLeanto = null;
    let topLeanto = null;
    let bottomLeanto = null;
    if ("leanto" in buildingInfo) {
      for(let i=0; i<buildingInfo.leanto.length; i++) {
        let leanto = buildingInfo.leanto[i];
        if (leanto.leanto_type === 1 || leanto.leanto_type === 2)
          totalWidth += leanto.width;
        if (leanto.leanto_type === 3 || leanto.leanto_type === 4)
          totalLength += leanto.width;
        if (leanto.leanto_type === 1)
          leftLeanto = leanto;
        if (leanto.leanto_type === 2)
          rightLeanto = leanto;
        if (leanto.leanto_type === 4)
          topLeanto = leanto;
        if (leanto.leanto_type === 3)
          bottomLeanto = leanto;
      }
    }
    const leftPadding = 50;
    const topPadding = 50;
    let drawWidth = 0;
    let drawLength = 0;
    let availableWidth = canvasWidth - leftPadding * 2;
    let availableLength = canvasHeight - topPadding * 2;
    if (availableWidth / availableLength <  totalWidth / totalLength)
    {
      drawWidth = availableWidth;
      drawLength = drawWidth * totalLength / totalWidth;
    } else {
      drawLength = availableLength;
      drawWidth = drawLength * totalWidth / totalLength;
    }

    let entry_points = {
      "c_b_f_w-fend": [], "c_b_r_w-rside": [],"F_S_L_R_W-fsrside":[], "c_b_l_w-lside": [], "c_b_b_w-bend": [],
      "F_L_F_W-flfside": [], "F_L_R_W-flfend": [], "F_L_L_W-flbend": [],
      "B_L_S_W-blbside": [], "B_L_B_W-blbend": [], "B_L_F_W-blfend": [],
      "L_L_L_W-lllside": [], "L_L_F_W-llfend": [], "L_L_B_W-llbend": [],
      "R_L_F_W-rlfend": [], "R_L_B_W-rlbend": [], "R_L_R_W-rlrside": [],
      "c_b_f_s_w-ufend": [], "c_b_l_s_w-sideul": [], "c_b_r_s_w-ulside": [],
      "c_b_f_s_b_w-fubend": [], "c_b_f_s_l_w-fulside": [], "c_b_f_s_r_w-furside": [],
      "c_b_l_s_f_w-lufend": [], "c_b_l_s_b_w-lubend": [], "c_b_l_s_r_w-rfend": [],
      "c_b_r_s_f_w-rufend": [], "c_b_r_s_b_w-rubend": [], "c_b_r_s_l_w-lfend": [],
      "L_L_F_S_W-llufend": [], "L_L_L_S_W-llulside": [], "L_L_R_S_W-llurside": [],
      "R_L_F_S_W-rlufend": [], "R_L_L_S_W-rlulside": [], "R_L_R_S_W-rrurside": [],
      "F_L_F_S_W-flulside": [], "F_L_R_S_W-flufend": [], "F_L_B_S_W-flurside": [],
      "B_L_L_S_W-bluside": [], "B_L_F_S_W-bluside": [], "B_L_B_S_W-blulside": [], "B_L_L_S_W-blufend": [],
      "FrontL-llfend": [], "BarnRight-rlrside": [], "BackR-llbend": [],
      "FrontL-rlfend": [], "BarnLeft-lllside": [], "BackR-rlbend": [],
      "FrontS-ufend": [], "RightS-ufend": [], "LeftS-ufend": [],
    };

    if ("entry_points" in buildingInfo) {
      for(let i=0; i<buildingInfo["entry_points"].length; i++) {
        let entry_point = buildingInfo["entry_points"][i];
        let entry_key = entry_point.component_wall_name;
        if ("entry_component_location" in entry_point)
          entry_key = entry_key + "-" + entry_point.entry_component_location;
        if (entry_key in entry_points)
          entry_points[entry_key].push(entry_point);
        else
          console.warn("------------Undefined key--------", entry_key);
      }
    }  
    let mainWidth = buildingInfo.width * drawWidth / totalWidth;
    let mainLength = buildingInfo.length * drawLength / totalLength;
    let leantoTopLength = 0;
    let leantoLeftWidth = 0;
    let leantoBottomLength = 0;
    let leantoRightWidth = 0;
    if (topLeanto !== null) {
      leantoTopLength = topLeanto.width * drawLength / totalLength;
    }
    if (bottomLeanto !== null) {
      leantoBottomLength = bottomLeanto.width * drawLength / totalLength;
    }
    if (leftLeanto !== null) {
      leantoLeftWidth = leftLeanto.width * drawWidth / totalWidth;
    }
    if (rightLeanto !== null) {
      leantoRightWidth = rightLeanto.width * drawWidth / totalWidth;
    }

    let top = topPadding;
    let left = (canvasWidth - drawWidth) / 2;
    let length = drawLength;
    let width = 0;
    let leantoLength;
    let leantoWidth;
    let utility_length;
    let utility_width;
    let layout = {};
    if (leftLeanto !== null) {
      width = leftLeanto.width * drawWidth / totalWidth;
      leantoLength = leftLeanto.length * drawLength / totalLength;
      layout = {
        left, top: top + leantoTopLength + this.getAlignmentOffset(leftLeanto, mainLength, leantoLength), width, length: leantoLength
      };
      this.drawLeanto(canvas, leftLeanto, layout);
      if ("porch" in leftLeanto) {
        if (topLeanto !== null && leftLeanto.porch!=undefined && leftLeanto.porch.wrap_with.includes('back')) {
          this.drawPorch(canvas, {
              left, top: top, width, length: leantoTopLength
            }, 'top-left', {"side_wall": leftLeanto["side_wall"], "back_wall": topLeanto["back_wall"]});
        }
        if (bottomLeanto !== null && leftLeanto.porch!=undefined  && leftLeanto.porch.wrap_with.includes('front')) {
          this.drawPorch(canvas, {
              left, top: top + leantoTopLength + mainLength, width, length: leantoBottomLength
            }, 'bottom-left', {"side_wall": leftLeanto["side_wall"], "back_wall": bottomLeanto["front_wall"]});
        }
      }
      if (leftLeanto['has_utility']) {
        let utility_length = layout.length * leftLeanto['utility_length'] / leftLeanto['length'];
        this.drawUtilityBorder(canvas, leftLeanto, {left, top: layout['top'] + this.getAlignmentOffset(leftLeanto, mainLength, leantoLength), width, length:utility_length});
        // "L_L_F_S_W-llufend": [], "L_L_L_S_W-llulside": [], "L_L_R_S_W-llurside": [],
        this.drawFrontBackEntryPoints(canvas, leftLeanto, entry_points["L_L_F_S_W-llufend"], 
          {left: layout.left, top: layout.top, width, length:utility_length}, 
          buildingInfo);
        this.drawLeftRightEntryPoints(canvas, leftLeanto, entry_points["L_L_L_S_W-llulside"], layout, buildingInfo);
        this.drawLeftRightEntryPoints(canvas, leftLeanto, entry_points["L_L_R_S_W-llurside"], layout, buildingInfo);
      }
      this.drawFrontBackEntryPoints(canvas, leftLeanto, entry_points["L_L_F_W-llfend"], layout, buildingInfo);
      this.drawFrontBackEntryPoints(canvas, leftLeanto, entry_points["L_L_B_W-llbend"], layout, buildingInfo);
      this.drawLeftRightEntryPoints(canvas, leftLeanto, entry_points["L_L_L_W-lllside"], layout, buildingInfo);

      left += width;
    }

    if (topLeanto !== null) {
      leantoWidth = topLeanto.length * drawWidth / totalWidth;
      leantoLength = topLeanto.width * drawLength / totalLength;
      layout = {
        left: left + this.getAlignmentOffset(topLeanto, mainWidth, leantoWidth), top: top, width: leantoWidth, length: leantoLength
      };
      this.drawLeanto(canvas, topLeanto, layout);
      if (topLeanto['has_utility']) {
        utility_width = layout.width * topLeanto['utility_length'] / topLeanto['length'];
        this.drawUtilityBorder(canvas, topLeanto, {left: layout['left'], top: top, width: utility_width, length:leantoLength});
        // "B_L_L_S_W-bluside": [], "B_L_F_S_W-bluside": [], "B_L_B_S_W-blulside": [],
        this.drawFrontBackEntryPoints(canvas, topLeanto, entry_points["B_L_F_S_W-bluside"], layout, buildingInfo);
        // this.drawLeftRightEntryPoints(canvas, topLeanto, entry_points["B_L_F_S_W-bluside"], layout, buildingInfo);
        this.drawLeftRightEntryPoints(canvas, topLeanto, entry_points["B_L_B_S_W-blulside"], layout, buildingInfo);
        this.drawLeftRightEntryPoints(canvas, topLeanto, entry_points["B_L_L_S_W-blufend"], 
          {left: layout.left, top: layout.top, width:utility_width, length:layout.length}, 
          buildingInfo);
      }
      this.drawFrontBackEntryPoints(canvas, topLeanto, entry_points["B_L_S_W-blbside"], layout, buildingInfo);
      this.drawLeftRightEntryPoints(canvas, topLeanto, entry_points["B_L_B_W-blbend"], layout, buildingInfo);
      this.drawLeftRightEntryPoints(canvas, topLeanto, entry_points["B_L_F_W-blfend"], layout, buildingInfo);
    }

    width = buildingInfo.width * drawWidth / totalWidth;
    length = buildingInfo.length * drawLength / totalLength;
    layout = {
      left, top: top + leantoTopLength, width, length
    };
    this.drawMainBuilding(canvas, buildingInfo, layout);
    if (buildingInfo['has_utility'] && buildingInfo['utility_name'] === 'back') {
      let utility_length = layout.length * buildingInfo['utility_length'] / buildingInfo['length'];
      this.drawUtilityBorder(canvas, buildingInfo, {left, top: layout['top'], width, length:utility_length});
      this.drawFrontBackEntryPoints(canvas, buildingInfo, entry_points["c_b_f_s_w-ufend"], 
        {left, top, width, length:utility_length}, 
        buildingInfo);
      this.drawLeftRightEntryPoints(canvas, buildingInfo, entry_points["c_b_l_s_w-sideul"], layout, buildingInfo);
      this.drawLeftRightEntryPoints(canvas, buildingInfo, entry_points["c_b_r_s_w-ulside"], layout, buildingInfo);
    }
    else if (buildingInfo['has_utility']) {
      let utility_name =  buildingInfo['utility_name'];
      let side_combo_width = layout.width * buildingInfo['utility_length'] / buildingInfo['width'];
      let side_combo_layout = {left, top: layout['top'], width: side_combo_width, length};
      if (utility_name === 'right') {
        side_combo_layout = {left: left + mainWidth - side_combo_width, top: layout['top'], width: side_combo_width, length};
      }
      this.drawSideUtilityBorder(canvas, buildingInfo, side_combo_layout);
      if (buildingInfo['utility_name'] === 'left') {
        this.drawLeftRightEntryPoints(canvas, buildingInfo, entry_points["c_b_l_s_r_w-rfend"], {
          left: layout.left, top: layout.top, width: side_combo_width, length: layout.length
        }, buildingInfo);
        this.drawFrontBackEntryPoints(canvas, buildingInfo, entry_points["c_b_l_s_f_w-lufend"], 
          {left: layout.left, top: layout.top, width: side_combo_width, length: layout.length,
          total_width: layout.width}, 
          buildingInfo);
        this.drawFrontBackEntryPoints(canvas, buildingInfo, entry_points["c_b_l_s_b_w-lubend"], 
          {left: layout.left, top: layout.top, width: side_combo_width, length: layout.length,
          total_width: layout.width}, 
          buildingInfo);
      }
      else { // right 
        this.drawLeftRightEntryPoints(canvas, buildingInfo, entry_points["c_b_r_s_l_w-lfend"], {
          left: layout.left + layout.width - side_combo_width, top: layout.top, width: side_combo_width, length: layout.length
        }, buildingInfo);
        this.drawFrontBackEntryPoints(canvas, buildingInfo, entry_points["c_b_r_s_f_w-rufend"], 
          {left: layout.left, top: layout.top, width: side_combo_width, length: layout.length,
          total_width: layout.width}, 
          buildingInfo);
        this.drawFrontBackEntryPoints(canvas, buildingInfo, entry_points["c_b_r_s_b_w-rubend"], 
          {left: layout.left, top: layout.top, width: side_combo_width, length: layout.length,
          total_width: layout.width}, 
          buildingInfo);
      }
    }

    this.drawFrontBackEntryPoints(canvas, buildingInfo, entry_points["c_b_f_w-fend"], layout, buildingInfo);
    this.drawFrontBackEntryPoints(canvas, buildingInfo, entry_points["c_b_b_w-bend"], layout, buildingInfo);
    this.drawLeftRightEntryPoints(canvas, buildingInfo, entry_points["c_b_r_w-rside"], layout, buildingInfo);
    this.drawLeftRightEntryPoints(canvas, buildingInfo, entry_points["F_S_L_R_W-fsrside"], layout, buildingInfo);
    this.drawLeftRightEntryPoints(canvas, buildingInfo, entry_points["c_b_l_w-lside"], layout, buildingInfo);

    if (bottomLeanto !== null) {
      leantoWidth = bottomLeanto.length * drawWidth / totalWidth;
      leantoLength = bottomLeanto.width * drawLength / totalLength;
      layout = {
        left: left + this.getAlignmentOffset(bottomLeanto, mainWidth, leantoWidth), top: top + leantoTopLength + mainLength, width: leantoWidth, length: leantoLength
      };
      this.drawLeanto(canvas, bottomLeanto, layout);
      if (bottomLeanto['has_utility']) {
        // "F_L_F_S_W-flulside": [], "F_L_R_S_W-flufend": [], "F_L_B_S_W-flurside": [],
        let utility_width = layout.width * bottomLeanto['utility_length'] / bottomLeanto['length'];
        this.drawUtilityBorder(canvas, bottomLeanto, {left: layout['left'], top: layout['top'], width: utility_width, length:leantoLength});
        this.drawFrontBackEntryPoints(canvas, bottomLeanto, entry_points["F_L_F_S_W-flulside"], 
          {left: layout.left, top: layout.top, width:layout.width, length:layout.length}, 
          buildingInfo);
        this.drawLeftRightEntryPoints(canvas, bottomLeanto, entry_points["F_L_B_S_W-flurside"], 
          {left: layout.left, top: layout.top, width:utility_width, length:layout.length}, 
          buildingInfo);
        this.drawLeftRightEntryPoints(canvas, bottomLeanto, entry_points["F_L_R_S_W-flufend"], 
          {left: layout.left, top: layout.top, width:utility_width, length:layout.length}, 
          buildingInfo);
      }
      this.drawFrontBackEntryPoints(canvas, bottomLeanto, entry_points["F_L_F_W-flfside"], layout, buildingInfo);
      this.drawLeftRightEntryPoints(canvas, bottomLeanto, entry_points["F_L_L_W-flbend"], layout, buildingInfo);
      this.drawLeftRightEntryPoints(canvas, bottomLeanto, entry_points["F_L_R_W-flfend"], layout, buildingInfo);
    }

    left += width;
    if (rightLeanto !== null) {
      width = rightLeanto.width * drawWidth / totalWidth;
      leantoLength = rightLeanto.length * drawLength / totalLength;
      layout = {
        left, top: top + leantoTopLength + this.getAlignmentOffset(rightLeanto, mainLength, leantoLength), width, length: leantoLength
      };
      this.drawLeanto(canvas, rightLeanto, layout);
      if ("porch" in rightLeanto) {
        if (topLeanto !== null && rightLeanto.porch!=undefined && rightLeanto.porch.wrap_with.includes('back')) {
          this.drawPorch(canvas, {
              left, top: top, width, length: leantoTopLength
            }, 'top-right', {"side_wall": rightLeanto["side_wall"], "back_wall": topLeanto["front_wall"]});
        }
        if (bottomLeanto !== null && rightLeanto.porch!=undefined && rightLeanto.porch.wrap_with.includes('front')) {
          this.drawPorch(canvas, {
              left, top: top + leantoTopLength + mainLength, width, length: leantoBottomLength
            }, 'bottom-right', {"side_wall": rightLeanto["side_wall"], "back_wall": bottomLeanto["front_wall"]});
        }
      }
      if (rightLeanto['has_utility']) {
        let utility_length = layout.length * rightLeanto['utility_length'] / rightLeanto['length'];
        this.drawUtilityBorder(canvas, rightLeanto, {left, top: layout['top'] + this.getAlignmentOffset(rightLeanto, mainLength, leantoLength), width, length:utility_length});
        // "R_L_F_S_W-rlufend": [], "R_L_L_S_W-rlulside": [], "R_L_R_S_W-rrurside": [],
        this.drawFrontBackEntryPoints(canvas, rightLeanto, entry_points["R_L_F_S_W-rlufend"], 
          {left: layout.left, top: layout.top, width: layout.width, length:utility_length}, 
          buildingInfo);
        this.drawLeftRightEntryPoints(canvas, rightLeanto, entry_points["R_L_L_S_W-rlulside"], layout, buildingInfo);
        this.drawLeftRightEntryPoints(canvas, rightLeanto, entry_points["R_L_R_S_W-rrurside"], layout, buildingInfo);
      }
      this.drawFrontBackEntryPoints(canvas, rightLeanto, entry_points["R_L_F_W-rlfend"], layout, buildingInfo);
      this.drawFrontBackEntryPoints(canvas, rightLeanto, entry_points["R_L_B_W-rlbend"], layout, buildingInfo);
      this.drawLeftRightEntryPoints(canvas, rightLeanto, entry_points["R_L_R_W-rlrside"], layout, buildingInfo);
    }

    // if (leftLeanto !== null || rightLeanto !== null) {
      const topOutterBound = new fabric.Line([
        (canvasWidth - drawWidth) / 2, top - 40,
        (canvasWidth + drawWidth) / 2, top - 40
       ],{
        fill: 'rgba(0,0,0,0)',
        stroke: 'black',
        selectable: false
      });
      canvas.add(topOutterBound);
      const textTopBorder = new fabric.Text("FULL WIDTH " + totalWidth.toString() + "\'", {
        fontSize: this.buildingFontSize,
        left: canvasWidth / 2,
        top: top - 40,
        fill: 'rgb(0,0,0)',
        backgroundColor: 'rgb(255,255,255)',
        originX: 'center',
        originY: 'center',
        fontWeight: 600,
      });
      canvas.add(textTopBorder);

      const bottomOutterBound = new fabric.Line([
        (canvasWidth - drawWidth) / 2, top + leantoTopLength + leantoBottomLength + length + 40,
        (canvasWidth + drawWidth) / 2, top + leantoTopLength + leantoBottomLength + length + 40
       ],{
        fill: 'rgba(0,0,0,0)',
        stroke: 'black',
        selectable: false
      });
      canvas.add(bottomOutterBound);
      const textBottomBorder = new fabric.Text("FULL WIDTH " + totalWidth.toString() + "\'", {
        fontSize: this.buildingFontSize,
        left: canvasWidth / 2,
        top: top + leantoTopLength + leantoBottomLength + length + 40,
        fill: 'rgb(0,0,0)',
        backgroundColor: 'rgb(255,255,255)',
        originX: 'center',
        originY: 'center',
        fontWeight: 600,
      });
      canvas.add(textBottomBorder);
    // }

    canvas.setBackgroundColor(mergedCanvasOption.backgroundColor, canvas.renderAll.bind(canvas));
    canvas.renderAll();
  }

  render() {
    const canvas_id = "fabric-canvas-" + this.props.purpose;
    return (
      <div>
        <canvas id={canvas_id}/>
      </div>
    );
  }
}
const mapDispatchToProps = {
  prepareTwoDMapData,
};
const mapStateToProps = (state) => {
  return { 
    twoDMapData: state.componentReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TwoDBuildingMap);
